<template>
  <div class="app">
    <loval-header :navs="data.nav"></loval-header>
    <div class="loval-main-container">
      <loval-nav :industries="data.industries"></loval-nav>
      <router-view></router-view>
    </div>
    <slider></slider>
  </div>
</template>

<script>
import LovalHeader from "@/components/LovalHeader.vue";
import LovalNav from "@/components/LovalNav.vue";
import Slider from "@/components/Slider.vue";
import DE from "../assets/strings/DE.json";
import EN from "../assets/strings/EN.json";
import ES from "../assets/strings/ES.json";

export default {
  data() {
    return {
      data: undefined
    };
  },
  name: "loval-main",
  components: {
    LovalHeader,
    LovalNav,
    Slider
  },
  created() {
    this.checkLang(this.$route);
    this.$route.params.content === undefined
      ? this.$router.push({
          path: "/" + this.$route.params.lang + "/services/default"
        })
      : null;
  },
  beforeRouteUpdate(to, from, next) {
    if (from.params.lang !== to.params.lang) {
      this.checkLang(to);
    }
    next();
  },
  methods: {
    checkLang(route) {
      switch (route.params.lang) {
        case "ES":
          this.data = ES;
          break;
        case "DE":
          this.data = DE;
          break;
        default:
          this.data = EN;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.app {
  max-width: 1600px;
  margin: auto;
  position: relative;
  z-index: 1;
  box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.3);
}
.loval-main-container {
  display: flex;
}
@media only screen and (min-width: 1200px) {
  .loval-main-container {
    background: var(--light-blue);
  }
}
</style>
